import { createTypes, createAsyncTypes } from '../../utils';

const prefix = 'pushNotification';

const types = createTypes(prefix, [
    'SHOW_PERMISSION_DIALOG',
    'HIDE_PERMISSION_DIALOG',
    'SHOW_REENABLEMENT_DIALOG',
    'HIDE_REENABLEMENT_DIALOG',
    'SET_CAMPAIGN_TO_SUBSCRIBE',
    'RESET_CAMPAIGN_TO_SUBSCRIBE',
    'REFRESH_CAMPAIGN_TAGS',
    'SEND_FIRST_PUSH',
    'AIRSHIP_REGISTRATION_SUCCESS',
    'RESET_AIRSHIP_REGISTRATION',
    'AIRSHIP_CHANNEL_CHANGE',
    'RESET_AIRSHIP_CHANNEL'
]);

const asyncTypes = createAsyncTypes(prefix, [
    'FETCH_NOTIFICATION_TAGS',
    'ADD_NOTIFICATION_TAG',
    'REMOVE_NOTIFICATION_TAG',
    'CHECK_REGISTRATION',
    'CHECK_OPTED_IN',
    'CHECK_SUPPORT',
    'CHECK_PERMISSION',
    'REGISTER',
    'SEND_PUSH',
]);

export default {
    ...types,
    ...asyncTypes
};
